import React, {useEffect, useMemo, useState} from 'react';
import DatePicker from 'react-datepicker';
import {ClipLoader} from "react-spinners";
// Assuming you're using react-loader-spinner
import Select from 'react-select';
import {useLocation, useNavigate} from "react-router-dom";
import qs from "query-string";
import MultiSelectCustom from "./MultiSelectCustom.js";
import {useDispatch, useSelector} from "react-redux";
import {accountantRequest, taskCompanyRequest, taskManagerRequest} from "../store/actions/task.js"; // Assuming you're using react-select

const TasksData = ({setFilter,limit_data, profession, manager_loader, animatedComponents, colourStyles}) => {
    const dispatch = useDispatch()
    const login = useSelector((state) => state.manager.employee);
    const location = useLocation()
    const query = qs.parse(location.search, {arrayFormat: 'comma'});
    const navigate = useNavigate()
    const [selectedCompany, setSelectedCompany] = useState([]);
    const [selectedAccountant, setSelectedAccountant] = useState([]);
    const [selectedManager, setSelectedManager] = useState(null);
    const [showMulti, setShowMulti] = useState('');
    const [manager, setManager] = useState([]);
    const [company, setCompanies] = useState([]);
    const [accountant, setAccountant] = useState([]);
    const account = useSelector((state) => state.task.accountant);
    const companies = useSelector((state) => state.task.companies);
    const managers = useSelector((state) => state.task.managers);
    const accountantArray = useSelector((state) => state.manager.accountantArray) || []

    const userId = useMemo(() => {
        const fromState = login?.user_id;
        if (fromState) {
            return Number(fromState);
        }
        const fromStorage = localStorage.getItem('user_id');
        return fromStorage ? Number(fromStorage) : null;
    }, [login?.user_id]);

    const managerUserIds = [86, 1024, 1734, 1918];
    const isManager = managerUserIds.includes(Number(userId));

    useEffect(() => {
        (async () => {
            if (managers) {
                setManager(managers.map(s => ({
                    value: s.id,
                    label: `${s.user.first_name} ${s.user.last_name}`.trim()
                })))
            }
            if (companies) {
                setCompanies(companies.map(s => ({value: s.id, label: s.name})))
            }

            if (account) {
                const allAccountants = account.map(s => ({
                    value: s.id,
                    label: `${s.user.first_name} ${s.user.last_name}`.trim()
                }));

                let accountantOptions = allAccountants;

                if (!isManager && accountantArray?.length) {
                    const allowedIds = new Set(accountantArray);
                    const filtered = account.filter(a => allowedIds.has(a.user_id)).map(s => ({
                        value: s.id,
                        label: `${s.user.first_name} ${s.user.last_name}`.trim()
                    }));
                    if (filtered.length) {
                        accountantOptions = filtered;
                    }
                }
                setAccountant(accountantOptions);
            }
            if (query.manager) {
                const managerId = parseInt(query.manager);
                const foundManager = managers.find(s => s.id === managerId);
                setSelectedManager(foundManager ? {
                    value: managerId,
                    label: `${foundManager.user.first_name} ${foundManager.user.last_name}`.trim()
                } : null)
            }
        })();
    }, [account, companies, accountantArray, managers, isManager, query.manager]);
    useEffect(() => {
        (async () => {
            await dispatch(accountantRequest())
            await dispatch(taskManagerRequest())
            await dispatch(taskCompanyRequest())
        })();
    }, []);
    useEffect(() => {
        if(query.accountant && !Array.isArray(query.accountant)){
            query.accountant = [query.accountant]
        }
        if(query.company && !Array.isArray(query.company)){
            query.company = [query.company]
        }
        query.page = 1

        setSelectedAccountant(query.accountant ? query.accountant.map(s => accountant.find(o => o?.value === parseInt(s))).filter(Boolean) : []);
        setSelectedCompany(query.company ? query.company.map(s => company.find(o => o?.value === parseInt(s))).filter(Boolean) : []);
    }, [location.search, accountant, company])
    const handleChangeDate = (type, date) => {
        if (type === 'start') {
            query.created_date = date.toISOString().split('T')[0]
            setFilter(prev => ({...prev,created_date: date.toISOString().split('T')[0]}))
        } else {
            setFilter(prev => ({...prev,created_date_end: date.toISOString().split('T')[0]}))
            query.created_date_end = date.toISOString().split('T')[0]
        }
        query.page = 1

        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
    };


    const onChangeSelectManager = (option) => {
        if (option) {
            query.manager = option.value;
        } else {
            delete query.manager; 
        }
        query.page = 1

        navigate(`?${qs.stringify(query, {
            arrayFormat: 'comma',
            skipEmptyString: true,
        })}`);
        setSelectedManager(option);
    };

    return (
        <div
            className={localStorage.getItem("profession") === "manager" ? 'tasks-data tasks-data-manager' : 'tasks-data'}>
      <span className='tasks-data-item'>
        <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={query.created_date || null}
            onChange={(date) => handleChangeDate('start', date)}
            showMonthYearDropdown/>
      </span>
            <div className='middle-line'/>
            <span className='tasks-data-item'>
        <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={query.created_date_end || null}
            showMonthYearDropdown
            onChange={(date) => handleChangeDate('end', date)}
        />
      </span>
            <div className='middle-line'/>
            <div className='tasks-data-hidden'>
                <div className='loader-filter'>
                    {limit_data?.loader_orgs ? <ClipLoader type="Oval" color="#949494" height={10} width={10}/> : ""}
                    <div className='task-multi-title' onClick={() => setShowMulti('company')}>
                        {!limit_data?.loader_orgs && selectedCompany[0]
                            ? `${selectedCompany[0].label} ${selectedCompany.length - 1? 'և ևս '+(selectedCompany.length - 1).toString():''}`
                            : "Ընտրել կազմակերպություն"}
                    </div>
                </div>
            </div>
            {profession !== "accountant" && !query.accountant_null  || query.accountant_null === 'false'? <div className='middle-line'/> : null}
            {profession !== "accountant" && !query.accountant_null  || query.accountant_null === 'false'? (
                <div className='tasks-data-hidden'>
                    <div className='task-multi-title' onClick={() => setShowMulti('accountant')}>
                        <div className='loader-filter'>
                            {limit_data?.loader_stuff ?
                                <ClipLoader type="Oval" color="#949494" height={10} width={10}/> : null}
                            {selectedAccountant[0] ? `${selectedAccountant[0].label} ${selectedAccountant.length - 1? 'և ևս '+(selectedAccountant.length - 1).toString():''}` : "Ընտրել աշխատակից"}
                        </div>
                    </div>
                </div>
            ) : null}
            {profession !== "accountant" && !query.accountant_null  || query.accountant_null === 'false'? <div className='middle-line'/> : null}
            {profession !== "accountant" && !query.accountant_null || query.accountant_null === 'false' ? (
                <div className='tasks-data-hidden'>
                    <Select
                        isLoading={manager_loader}
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                border: 'none',
                                boxShadow: 'none', // Removes focus outline
                            }),
                        }}
                        value={selectedManager}
                        closeMenuOnSelect={false}
                        components={animatedComponents}
                        options={isManager ? manager : manager.filter(m => m.value === Number(userId)).length ? manager.filter(m => m.value === Number(userId)) : manager}
                        onChange={onChangeSelectManager}
                        isClearable={true}
                        placeholder="Մենեջեր"
                    />
                </div>
            ) : null}
            {showMulti === 'company' ?
                <MultiSelectCustom
                    setFilter={setFilter}
                    selected={selectedCompany}
                    setSelected={setSelectedCompany}
                    setOpen={setShowMulti}
                    options={company}
                    open={showMulti}
                /> : null}
            {showMulti === 'accountant' ?
                <MultiSelectCustom
                    setFilter={setFilter}
                    selected={selectedAccountant}
                    setSelected={setSelectedAccountant}
                    setOpen={setShowMulti}
                    options={accountant}
                    open={showMulti}
                /> : null}
        </div>
    );
};

export default TasksData;
